module.exports = __webpack_public_path__ + "media/components/shared/static/gallery-black-0338a81c5ea235d274a3e0567651231f.svg";